import { useState, useEffect } from 'react';

// Benutzerdefinierte Cursor-Komponente
const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  // Mausbewegung, Sichtbarkeit und Klick verfolgen
  useEffect(() => {
    const updateCursorPosition = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      const isInsideDocument =
        e.clientX >= 0 &&
        e.clientY >= 0 &&
        e.clientX <= window.innerWidth &&
        e.clientY <= window.innerHeight;
      setIsVisible(isInsideDocument);
    };

    const hideCursor = (e) => {
      if (!e.relatedTarget || e.relatedTarget === document) {
        setIsVisible(false);
      }
    };

    const showCursor = () => {
      setIsVisible(true);
    };

    const handleMouseDown = () => {
      setIsClicked(true);
      // Cursor nach 200ms zurücksetzen
      setTimeout(() => {
        setIsClicked(false);
      }, 200);
    };

    // Event-Listener hinzufügen
    document.addEventListener('mousemove', updateCursorPosition);
    document.addEventListener('mouseout', hideCursor);
    document.addEventListener('mouseenter', showCursor);
    document.addEventListener('mousedown', handleMouseDown);

    // Prüfen, ob Touch-Gerät vorhanden ist
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    if (isTouchDevice) {
      setIsVisible(false); // Cursor ausblenden auf Touch-Geräten
    }

    // Cleanup bei Unmount
    return () => {
      document.removeEventListener('mousemove', updateCursorPosition);
      document.removeEventListener('mouseout', hideCursor);
      document.removeEventListener('mouseenter', showCursor);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, []);

  return (
    <>
      {/* CSS für den Cursor und das Beispiel-Element */}
      <style>
        {`
  
       
        `}
      </style>

      {/* Kreisförmiger Cursor */}
      <div
        className={`custom-cursor ${isVisible ? 'visible' : ''} ${isClicked ? 'clicked' : ''}`}
        style={{ left: `${position.x}px`, top: `${position.y}px` }}
      />
      {/* Beispiel-Element mit Hover-Effekt (optional) */}

    </>
  );
};

export default CustomCursor;

/* Hinweis:
   - Um den Standardcursor überall auf der Webseite auszublenden, fügen Sie folgendes in Ihre globale CSS-Datei (z. B. index.css) ein:
     body {
       cursor: none;
     }
   - Das CSS kann in eine separate Datei (z. B. CustomCursor.css) ausgelagert und importiert werden, z. B.:
     import './CustomCursor.css';
   - Der Cursor folgt der Maus sofort und exakt ohne Versatz, ist nur sichtbar, wenn die Maus im Dokument ist, und wird ausgeblendet, wenn die Maus das Dokument verlässt oder auf Touch-Geräten. Bei einem Klick wird der Cursor kurzzeitig größer (40px) für 200ms.
   - Passen Sie Farben (#3b82f6, #ef4444), Größen (20px, 40px), Dauer (200ms) oder andere Stile nach Bedarf an.
*/